export default __webpack_public_path__ + "static/media/slide3.8bfef0a4.jpg";